import React from 'react';

import type { TypographyProps } from './types';
import { StyledSpan } from './StyledComponents';

export const Span = ({
  children,
  isTermsContent,
  testID,
  ...rest
}: TypographyProps): React.ReactElement => (
  <StyledSpan data-testid={testID} isTermsContent={isTermsContent} {...rest}>
    {children}
  </StyledSpan>
);
